// extracted by mini-css-extract-plugin
var _1 = "BuyTradePageStyle-module__arrow-icon___Arqi6";
var _2 = "BuyTradePageStyle-module__arrow-icon-big___lh8Fz";
var _3 = "BuyTradePageStyle-module__arrow-icon___Arqi6";
var _4 = "BuyTradePageStyle-module__arrow-icon-big___lh8Fz";
var _5 = "BuyTradePageStyle-module__bold___plPh2";
var _6 = "BuyTradePageStyle-module__btn___Xl0aJ";
var _7 = "BuyTradePageStyle-module__btn-active___QHiS1";
var _8 = "BuyTradePageStyle-module__btn-active-disabled___XKSi7";
var _9 = "BuyTradePageStyle-module__btn-block___PmRP1";
var _a = "BuyTradePageStyle-module__btn-cancel___QRKjR";
var _b = "BuyTradePageStyle-module__btn-disabled___Q6Uwn";
var _c = "BuyTradePageStyle-module__btn-no-padding___cn2Qf";
var _d = "BuyTradePageStyle-module__btn-secondary___jhLsk";
var _e = "BuyTradePageStyle-module__btn-success___yujOT";
var _f = "BuyTradePageStyle-module__btn-success-disabled___MP9_g";
var _10 = "BuyTradePageStyle-module__btn-transparent___onGZv";
var _11 = "BuyTradePageStyle-module__btn-active___QHiS1";
var _12 = "BuyTradePageStyle-module__btn-active-disabled___XKSi7";
var _13 = "BuyTradePageStyle-module__btn-block___PmRP1";
var _14 = "BuyTradePageStyle-module__btn-cancel___QRKjR";
var _15 = "BuyTradePageStyle-module__btn-disabled___Q6Uwn";
var _16 = "BuyTradePageStyle-module__btn-no-padding___cn2Qf";
var _17 = "BuyTradePageStyle-module__btn-secondary___jhLsk";
var _18 = "BuyTradePageStyle-module__btn-success___yujOT";
var _19 = "BuyTradePageStyle-module__btn-success-disabled___MP9_g";
var _1a = "BuyTradePageStyle-module__btn-transparent___onGZv";
var _1b = "BuyTradePageStyle-module__cancel-button___QyN8v";
var _1c = "BuyTradePageStyle-module__cancel-button-big___uEijM";
var _1d = "BuyTradePageStyle-module__cancel-button___QyN8v";
var _1e = "BuyTradePageStyle-module__cancel-button-big___uEijM";
var _1f = "BuyTradePageStyle-module__container___mBF9Z";
var _20 = "BuyTradePageStyle-module__left___NElxp";
var _21 = "BuyTradePageStyle-module__right___Npf6Y";
export { _1 as "arrow-icon", _2 as "arrow-icon-big", _3 as "arrowIcon", _4 as "arrowIconBig", _5 as "bold", _6 as "btn", _7 as "btn-active", _8 as "btn-active-disabled", _9 as "btn-block", _a as "btn-cancel", _b as "btn-disabled", _c as "btn-no-padding", _d as "btn-secondary", _e as "btn-success", _f as "btn-success-disabled", _10 as "btn-transparent", _11 as "btnActive", _12 as "btnActiveDisabled", _13 as "btnBlock", _14 as "btnCancel", _15 as "btnDisabled", _16 as "btnNoPadding", _17 as "btnSecondary", _18 as "btnSuccess", _19 as "btnSuccessDisabled", _1a as "btnTransparent", _1b as "cancel-button", _1c as "cancel-button-big", _1d as "cancelButton", _1e as "cancelButtonBig", _1f as "container", _20 as "left", _21 as "right" }
